import React, { useState } from "react";
import { Link } from "react-router-dom";
import products from "../components/products";          // ✅ points to src/data/products.js
import "./Products.css";
import { FaThLarge, FaTh, FaList } from "react-icons/fa";
import NavBar from "../components/Navbar";        // ✅ no .jsx needed

const Products = () => {
  // default view is "small" → 4 products per row
  const [view, setView] = useState("small");

  return (
    <>
      <NavBar textColor="#000" />
      <div className={`products-page ${view}-view`}>
        <h1>Our Products</h1>

        {/* View toggle */}
        <div className="view-toggle">
          <FaThLarge
            className={`toggle-icon ${view === "large" ? "active" : ""}`}
            onClick={() => setView("large")}
            title="2-per-row view"
          />
          <FaTh
            className={`toggle-icon ${view === "small" ? "active" : ""}`}
            onClick={() => setView("small")}
            title="4-per-row view"
          />
          <FaList
            className={`toggle-icon ${view === "list" ? "active" : ""}`}
            onClick={() => setView("list")}
            title="single-row list view"
          />
        </div>

        {/* Product list */}
        <div className="product-list">
          {products.map((prod) => (
            <Link
              to={`/product/${prod.id}`}
              key={prod.id}
              className="product-card"
            >
              <div className="product-image">
                <img
                  src={prod.images?.[0]?.src || prod.images?.[0]}
                  alt={prod.title}
                />
              </div>
              <h2>{prod.title}</h2>
            </Link>
          ))}
        </div>
      </div>
    </>
  );
};

export default Products;
